import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUndo = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M5.83398 15.834V14.1673H11.7507C12.6257 14.1673 13.3861 13.8895 14.0319 13.334C14.6777 12.7784 15.0007 12.084 15.0007 11.2507C15.0007 10.4173 14.6777 9.72287 14.0319 9.16732C13.3861 8.61176 12.6257 8.33398 11.7507 8.33398H6.50065L8.66732 10.5007L7.50065 11.6673L3.33398 7.50065L7.50065 3.33398L8.66732 4.50065L6.50065 6.66732H11.7507C13.0979 6.66732 14.2541 7.10482 15.2194 7.97982C16.1847 8.85482 16.6673 9.9451 16.6673 11.2507C16.6673 12.5562 16.1847 13.6465 15.2194 14.5215C14.2541 15.3965 13.0979 15.834 11.7507 15.834H5.83398Z",
		fill: "black",
		fillOpacity: .6
	})]
});
const ForwardRef = forwardRef(SvgUndo);
export { ForwardRef as ReactComponent };
